import { render, staticRenderFns } from "./JBProposalExihibitionsDisplays.vue?vue&type=template&id=19a5b9cd"
import script from "./JBProposalExihibitionsDisplays.vue?vue&type=script&lang=js"
export * from "./JBProposalExihibitionsDisplays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports